import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  EditButton,
  DeleteButton
} from 'react-admin'
import RichTextInput from 'ra-input-rich-text'
import Button from '@material-ui/core/Button'
import axios from 'axios'

import { toolbarOptions } from '../../utils/reachTextEditor'
import config from '../../config'
import EditToolbar from '../../components/EditToolbar'

const EmptyPagination = props => <span />

// Bumps the version for ALL sections at once. Use this after editing the
// sections you want — individual section saves no longer change the version.
class PublishVersionButton extends React.Component {
  state = { loading: false }

  publish = async () => {
    if (!window.confirm('Publish a new version? This bumps the version number for all sections at once.')) {
      return
    }
    try {
      this.setState({ loading: true })
      const res = await axios.put('/terms-publish')
      window.alert(`Published version ${res.data.version}.0`)
      window.location.reload()
    } catch (err) {
      window.alert('Failed to publish a new version. Please try again.')
      this.setState({ loading: false })
    }
  }

  render () {
    return (
      <Button
        variant='contained'
        color='primary'
        disabled={this.state.loading}
        onClick={this.publish}
      >
        {this.state.loading ? 'Publishing…' : 'Publish New Version'}
      </Button>
    )
  }
}

export const TermList = (props) =>{
  const StateLink = ({ record = {} }) => {
    return (<div>
       <p>{record.version + ".0"}</p>
       {record.hasDraft &&
         <p style={{ color: '#c77700', fontWeight: 'bold', margin: '2px 0' }}>Unpublished changes</p>}
       <a href={`/#/terms-version?id=${record.id}`} className='self-link' target='_blank' rel="noopener noreferrer" >Want to see previous versions?</a>

    </div>)

  }
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p className='page-title'>Terms</p>
        <PublishVersionButton />
      </div>
      <List title='All Terms' bulkActions={false} {...props} pagination={<EmptyPagination />} perPage={config.perPage}>
        <Datagrid>
          <TextField source='_id' />
          <TextField source='categoryName' />
          <StateLink source='state' label='Active Version'  />
          <EditButton />
          <DeleteButton />
        </Datagrid>
      </List>
    </div>
  
  )
} 

export const TermEdit = (props) => (
  <Edit title='Edit Term' {...props}>
    <SimpleForm toolbar={<EditToolbar />}>
      <DisabledInput label='Id' source='_id' />
      <TextInput source='categoryName' />
      <RichTextInput source='content' addLabel={false} toolbar={toolbarOptions} />
    </SimpleForm>
  </Edit>
)

export const TermCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source='categoryName' />
      <RichTextInput source='content' addLabel={false} toolbar={toolbarOptions} />
    </SimpleForm>
  </Create>
)
